// John Eldhose 20181004
import React, { Component } from 'react';
import ProfileAddress from '../lib/ProfileAddress';
import Loading from '../lib/Loading';
import { postData } from '../lib/api';

class PhotoCapture extends Component {

  state = {
    profile: null,
    address: null
  }
  componentWillMount() {
    if(this.props.prompt === false) {
      postData('getProfile', {})
        .then((res) => {
          if(res.status === 'true')
            this.setState({ profile: res.data });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ step: 'error' });
        })
    }
  }
  componentDidUpdate() {
    if(typeof this.refs.cpcform !== 'undefined')
      this.refs.cpcform.submit();
  }
  content = () => {
    if(
      this.props.prompt === true &&
      (this.state.profile === null || this.state.address === null)
    )
      return (
        <ProfileAddress
          NoBillTo={true}
          Back={() => window.close()}
          Continue={(p, a) => this.setState({ profile: p, address: a })}
        />
      );
    else if(this.props.prompt === false && this.state.profile === null)
      return <Loading />;
    else {
      var prof = this.state.profile; var addr = this.state.address;
      if(this.props.prompt === false)
        addr = {ADDRESS1:'',CITY:'',STATE:'',COUNTRY:'',POSTALCODE:''};
      return (
        <form
          ref='cpcform'
          action='https://photocapture.carlsonsw.com/custauth.php'
          method='post'
        >
          <input type='hidden' name='CompanyDescription' value={prof.CompanyDescription} />
          <input type='hidden' name='FirstName' value={prof.FirstName} />
          <input type='hidden' name='LastName' value={prof.LastName} />
          <input type='hidden' name='email' value={prof.email} />
          <input type='hidden' name='phone' value={prof.phone} />
          <input type='hidden' name='session' value={prof.session} />
          <input type='hidden' name='username' value={prof.username} />
          <input type='hidden' name='ADDRESS1' value={addr.ADDRESS1} />
          <input type='hidden' name='CITY' value={addr.CITY} />
          <input type='hidden' name='STATE' value={addr.STATE} />
          <input type='hidden' name='COUNTRY' value={addr.COUNTRY} />
          <input type='hidden' name='POSTALCODE' value={addr.POSTALCODE} />
        </form>
      );
    }
  }

  render() {
    return (
      <div style={{ padding: '15px' }}>
        {this.content()}
      </div>
    );
  }
}

export default PhotoCapture;



// WEBPACK FOOTER //
// ./src/components/home/PhotoCapture.js